import { ComponentType } from 'react';
import {
  BlockViewProps,
  ChecksView,
  ProcedureParametersView,
  CoverageView,
  DataFilesView,
  DutBlockView,
  EquipmentBlockView,
  FieldBlockView,
  FigureIndexView,
  FindingsView,
  GalleryBlockView,
  ReadingsBlockView,
  ResultsMatrixView,
  StepsBlockView,
  TableIndexView,
  TextBlockView,
} from './StandardBlockViews';
import { LimitChartView, LimitListView, LimitsView } from './LimitBlockViews';

export type { BlockViewProps } from './StandardBlockViews';

/** A block type's React half: draws one block of a composed report. */
export type BlockView = ComponentType<BlockViewProps<any>>;

/** The SDK's block views, by block type; a report adds its own beside them. */
export const STANDARD_BLOCK_VIEWS: Record<string, BlockView> = {
  text: TextBlockView,
  field: FieldBlockView,
  readings: ReadingsBlockView,
  gallery: GalleryBlockView,
  dut: DutBlockView,
  equipment: EquipmentBlockView,
  steps: StepsBlockView,
  'results-matrix': ResultsMatrixView,
  coverage: CoverageView,
  limits: LimitsView,
  'limit-list': LimitListView,
  'limit-chart': LimitChartView,
  checks: ChecksView,
  'procedure-parameters': ProcedureParametersView,
  'data-files': DataFilesView,
  findings: FindingsView,
  'figure-index': FigureIndexView,
  'table-index': TableIndexView,
};
